import { render, staticRenderFns } from "./LoginVerifyPageComponent.vue?vue&type=template&id=0a86a4a0&scoped=true"
import script from "./LoginVerifyPageComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginVerifyPageComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginVerifyPageComponent.vue?vue&type=style&index=0&id=0a86a4a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a86a4a0",
  null
  
)

export default component.exports